import { Observable } from "rxjs";

export default class Entity {
    constructor(data) {
        this._values = {};
        this._attributeKeys = [];
        this.subscribers = [];

        for (const key in data) {
            this._values[key] = data[key];
            this._attributeKeys.push(key);

            if (this[key] == undefined) {
                Object.defineProperty(this, key, { 
                    get: function() {
                        return this._values[key];
                    },

                    set: function(newValue) {
                        this._values[key] = newValue;
                    }
                });
            }
        }
    }

    get attributeKeys() {
        return this._attributeKeys;
    }

    set attributeKeys(value) {
        this.setAttributeKeys(value);
    }

    setAttributeKeys(attributeKeys) {
        this._attributeKeys = attributeKeys;

        for (const key of attributeKeys) {
            if (this[key] == undefined) {
                Object.defineProperty(this, key, { 
                    get: function() {
                      return this._values[key];
                    },
        
                    set: function(newValue) {
                      this._values[key] = newValue;
                    }
                });
            }
        }
    }

    get(attributeName) {
        return this._values[attributeName];
    }

    set(attributeName, value) {
        if (!this._values[attributeName]) {
            if (this[attributeName] == undefined) {
                this.attributeKeys.push(attributeName);
                Object.defineProperty(this, attributeName, { 
                    get: function() {
                        return this._values[attributeName];
                    },

                    set: function(newValue) {
                        this._values[attributeName] = newValue;
                    }
                });
            }
        }

        this._values[attributeName] = value;
    }

    toJSON() {
        const json = {};

        for (const key of this.attributeKeys) {
            const value = this._values[key];
            if (value != undefined) {
                json[key] = this._values[key];
            }
        }

        return JSON.parse(JSON.stringify(json));
    }

    updateFrom(entity) {
        if (entity) {
            for (var attributeKey of this.attributeKeys) {
                this[attributeKey] = entity[attributeKey];
            }
        }
    }

    observe() {
        this.observable = new Observable((subscriber) => {
            this.subscribers.push(subscriber);
        });
        return this.observable;
    }
}